import { CombinedActionTypes } from '../../actionsFactory';

export interface State {
  loading: boolean;
  error?: any;
  data: string[];
  unreadActions: number;
  meta?: {
    page: number;
    totalHits: number;
    pageSize: number;
  };
}

export const initState: State = {
  loading: false,
  error: null,
  data: [],
  unreadActions: 0,
  meta: null,
};

export default (state: State, action: CombinedActionTypes): State => {
  switch (action.type) {
    case 'ACTIONS_REQUIRED:FETCHING':
      return {
        ...state,
        loading: true,
        error: null,
        meta: {
          ...state.meta,
          page: action.payload.page,
        },
      };
    case 'ACTIONS_REQUIRED:FETCHING_ERROR':
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case 'ACTIONS_REQUIRED:FETCHING_SUCCESS':
      const actionsRequired = action.payload.result.data;

      return {
        ...state,
        loading: false,
        error: null,
        data: actionsRequired.map(({ id }) => id),
        unreadActions: actionsRequired.filter(
          ({ lastUserRequest }) => lastUserRequest?.status === 'UNREAD',
        ).length,
        meta: {
          ...action.payload.result.meta,
          totalHits: parseInt(action.payload.result.meta.totalHits, 10),
          pageSize: parseInt(action.payload.result.meta.pageSize, 10),
          page: parseInt(action.payload.result.meta.page, 10),
        },
      };
    default:
      return state;
  }
};
